/* global RongIMLib RongIMClient RongRTC */
export default {
  name: 'broadcastRoomDetail',
  data () {
    return {
      IM: '',
      userId: '',
      roomId: '',
      liveUrl: '',
      avator: '',
      userName: '',
      room_account: '',
      VideoTag: 'RongCloudRTC',
      videoStreamId: '',
      rongRoom: '',
      userInput: '',
      btnDisabled: true,
      currentAudience: 0,
      curentShow: 0,
      isShowSelect: true,
      isShowGift: false,
      isShowEmoji: false,
      uploadVideoUrl: '',
      emojiList: [],
      banText: '设置封禁时长',
      currentTime: '1',
      giftInfo: {
        avator: '',
        giftIcon: '',
        giftName: '',
        name: '',
        number: ''
      },
      banUser: {
        room_account: '',
        chat_account: '',
        minute: ''
      },
      banTime: [
        {label: 1, value: '1'},
        {label: 10, value: '10'},
        {label: 20, value: '20'},
        {label: 30, value: '30'},
        {label: 40, value: '40'},
        {label: 50, value: '50'},
        {label: 60, value: '60'}
      ],
      existUserList: [], // 直播间已存在的用户列表
      inoutList: [
      ], // 右侧展示的当前用户列表
      selectInoutList: [
        [], // 聊天消息列表
        [] // 礼物列表
      ], // 右侧展示的所有类别列表
      userList: [], // 左侧展示的当前用户列表
      selectUserList: [
        [], // 在线用户
        [], // 禁言用户
        [] // 封禁用户
      ], // 左侧展示的所有类别的用户列表
      audienceList: [
        {title: '在线用户', key: 0},
        {title: '禁言用户', key: 1},
        {title: '封禁用户', key: 2}
      ],
      detailList: [
        {title: '关注', value: '0', key: 'concernCount', icon: require('../../../assets/images/liveIcon/icon_following.png')},
        {title: '礼物', value: '0', key: 'giftCount', icon: require('../../../assets/images/liveIcon/icon_gift.png')},
        {title: '获赞', value: '0', key: 'praiseCount', icon: require('../../../assets/images/liveIcon/icon_like.png')}
      ],
      showList: [
        {title: '聊天', key: 0, type: 'message'},
        {title: '礼物', key: 1, type: 'gift'}
      ],
      iconList: [
        { url: require('../../../assets/images/liveIcon/icon_screenshare.png'), key: 0 },
        // {url: require('../../../assets/images/liveIcon/icon_video.png'), key: 0},
        { url: require('../../../assets/images/liveIcon/icon_voice_on.png'), key: 0 }
        // {url: require('../../../assets/images/liveIcon/icon_setting.png'), key: 0},
      ],
      actionList: [
        // {text: '邀请连麦', url: require('../../../assets/images/liveIcon/icon_voice_on.png'), key: 0},
        {text: '实施封禁', url: require('../../../assets/images/liveIcon/icon_microphone.png'), key: 1},
        {text: '实施禁言', url: require('../../../assets/images/liveIcon/icon_notalk.png'), key: 2}
      ],
      config: {
        appkey: 'vnroth0kvbsmo',
        token: 'KeDdz2YA2NJO4xxKyOQeVy833cJyDBff3X5P7s0A2GI=@rl7p.cn.rongnav.com;rl7p.cn.rongcfg.com'
      }
    };
  },
  watch: {
    userInput (_new, old) {
      if (_new.length) {
        this.btnDisabled = false;
      } else {
        this.btnDisabled = true;
      }
    }
  },
  created () {
    if (this.$route.query.id) {
      this.getDetail(this.$route.query.id);
    }
  },
  mounted () {
    window.addEventListener('unload', () => this.unload());
    document.body.addEventListener('click', this.handleClickBody, false);
  },
  methods: {
    unload () {
      // this.reqCloseRoom();
      this.quitRoom();
      document.body.removeEventListener('click', this.handleClickBody, false);
    },
    getDetail (id) {
      this.$get({
        url: `/live/rooms/${id}`
      }).then(({data}) => {
        this.liveUrl = data.liveUrl;
        let user = data.user;
        this.roomId = String(data.hmRoomId);
        this.room_account = data.rcRoomId;
        this.userName = user.nickName;
        this.avator = user.portraitUri;
        this.existUserList = data.members;
        this.detailList.forEach(item => {
          for (let k in user) {
            if (item.key === k) {
              item.value = user[k];
            }
          }
        });
        // this.initMyIM();
        this.initIM(this.config);
      });
    },
    initIM (params) {
      /* IM 初始化 */
      RongIMLib.RongIMClient.init(params.appkey);
      RongIMClient.setConnectionStatusListener({
        onChanged: (status) => {
          if (status === 0) {
            // emoji 初始化
            RongIMLib.RongIMEmoji.init();
            let list = RongIMLib.RongIMEmoji.list;
            this.emojiList = list;
          }
        }
      });
      RongIMClient.setOnReceiveMessageListener({
        onReceived: (message) => {
          this.handleReciveMessage(message);
        }
      });
      this.initRoomMessage();
      // this.initSendMessage();
      // setMessageListener
      /* IM 连接 */
      if (RongIMClient.getInstance().getCurrentConnectionStatus() === 0) {
        // 说明以已经链接了 直接初始化RTC就行
        this.initMyRTC();
      } else {
        RongIMClient.connect(params.token, {
          onSuccess: (userId) => {
            this.userId = userId;
            this.initMyRTC();
          },
          onTokenIncorrect: () => {},
          onError: (errorCode) => {}
        });
      }
    },
    initRTC () {
      let rongRTC = new RongRTC({
        RongIMLib: RongIMLib,
        mode: RongRTC.Mode.LIVE,
        liveRole: RongRTC.ROLE.ANCHOR
      });
      let rongRoom = new rongRTC.Room({
        id: 2020,
        joined: function (user) {
        },
        left: function (user) {
          let del = document.getElementById(user.id);
          del.parentNode.removeChild(del);
        }
      });
    },
    initMyIM () {
      const im = RongIMLib.init({ appkey: this.config.appkey });
      this.IM = im;
      let token = this.config.token;
      if (im.getConnectionStatus() !== 0) {
        // 等于0 说明已经链接 不需要在去链接了。
        im.connect({ token }).then(user => {
          this.userId = user.id;
          this.initMyRTC();
        }).catch(() => {});
      } else {
        this.initMyRTC();
      }
    },
    initMyRTC () {
      // 观众初始化
      let rongRTC = new RongRTC({
        RongIMLib: RongIMLib,
        mode: RongRTC.Mode.LIVE,
        liveRole: RongRTC.ROLE.AUDIENCE
      });
      let { Room, Stream } = rongRTC; // StreamType Storage Device Message

      let room = new Room({
        id: this.roomId,
        joined: (user) => {
          // user.id 加入房间
        },
        left: (user) => {
          // user.id 离开房间
          let F = document.querySelector('.view-list');
          let nodeList = F.childNodes;
          if (nodeList.length) {
            nodeList.forEach((item, index) => {
              if (item.id === user.id) {
                F.removeChild(nodeList[index]);
              }
            });
          }
        }
      });
      this.rongRoom = room;

      let stream = new Stream({
        /* 成员已发布资源，此时可按需订阅 */
        published: (user) => {
          stream.subscribe(user).then((user) => {
            // let {id, stream: {tag, mediaStream}} = user;
            // let node = document.createElement('video');
            // let F = document.querySelector('.view-list')
            // node.classList.add("call-view");
            // node.id = user.id;
            // node.autoplay = true;
            // node.srcObject = mediaStream;
            // F.appendChild(node);
            // 将 node 添加至页面或指定容器
          });
        },
        /* 成员已取消发布资源，此时需关闭流 */
        unpublished: (user) => {
          stream.unsubscribe(user);
        }
      });
      stream.subscribe({ liveUrl: this.liveUrl }).then((res) => {
        // 此时订阅成功主播视频
        this.addMessageRoom(); // 订阅成功后加入聊天室
        let { mediaStream } = res;
        let node = document.createElement('video');
        let videoBox = document.getElementsByClassName('rong-video-box')[0];

        node.id = this.userId;
        node.autoplay = true;
        node.srcObject = mediaStream;
        videoBox.appendChild(node);
      }).catch(err => {
        if (err.code === 45001) {
          this.$message.error('该直播已关闭！');
        }
      });
    },
    addUserStream (user) {
      let parentDom = document.querySelector('.rong-video-box');
      let videoDom = this.createVideo(user.stream.mediaStream);
      videoDom.id = user.id;
      parentDom.appendChild(videoDom);
    },
    createVideo (stream) {
      let video = document.createElement('video');
      video.srcObject = stream;
      video.autoplay = true;
      return video;
    },
    getDom (key) {
      return document.querySelector(key);
    },
    setStyle (e) {
      let rongInput = document.getElementsByClassName('rong-input');
      for (let j = 0, len = rongInput.length; j < len; j++) {
        rongInput[j].classList.remove('active');
      }
      e.classList.add('active');
    },

    removeUserStream () {
      let parentDom = document.querySelector('.rong-video-box');
      parentDom.innerHTML = '已关闭该直播间！';
    },
    handleClickAudience (item) {
      this.currentAudience = item.key;
      this.userList = JSON.parse(JSON.stringify(this.selectUserList[item.key]));
    },
    handleClickShow (item) {
      this.curentShow = item.key;
      this.inoutList = JSON.parse(JSON.stringify(this.selectInoutList[item.key]));
    },
    closeRoom (e) {
      this['$confirm']({
        title: '关闭直播后，主播和观众都将被中止，确认关闭吗',
        okType: 'danger',
        centered: true,
        onOk: () => {
          this.sendConfigMessage({type: 3});
        }
      });
    },
    initSendMessage () {
      let messageName = 'PersonMessage'; // 消息名称
      let objectName = 's:person'; // 消息类型名，请按照此格式命名
      let isCounted = true; // 消息计数
      let isPersited = true; // 消息保存
      let mesasgeTag = new RongIMLib.MessageTag(isCounted, isPersited);
      let prototypes = ['action', 'name', 'desc', 'viewerId', 'type', 'avator', 'msgType', 'key', 'isShowAction']; // 消息类中的属性名
      RongIMClient.registerMessageType(messageName, objectName, mesasgeTag, prototypes);
    },
    quitRoom () {
      let chatRoomId = this.roomId; // 聊天室 Id
      let callback = {
        onSuccess: () => {
          let info = {
            key: new Date().getTime(),
            type: 1, // 1 是聊天列表
            avator: JSON.parse(localStorage.userInfo).avatar_url,
            action: '退出了直播间',
            name: JSON.parse(localStorage.userInfo).user_name,
            desc: '',
            viewerId: this.userId,
            isShowAction: false,
            id: JSON.parse(localStorage.userInfo).chat_account,
            roomId: this.roomId
          };
          this.sendRoomMessage(info);
          RongIMClient.getInstance().disconnect();
        },
        onError: () => {}
      };
      RongIMClient.getInstance().quitChatRoom(chatRoomId, callback);
    },
    sendConfigMessage (info) {
      let conversationType = RongIMLib.ConversationType.PRIVATE;
      let targetId = this.$route.query.userId;
      let msg = new RongIMClient.RegisterMessage.PersonMessage(info);

      let callback = {
        onSuccess: (message) => {
          if (message.content.type === 3) {
            this.removeUserStream();
          }
        },
        onError: (errorCode) => {
        }
      };
      RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, callback);
    },
    // 打字发送消息
    sendMsgToList () {
      let text = this.userInput;
      let obj = {
        type: 2,
        avator: this.avator,
        name: JSON.parse(localStorage.userInfo).user_name,
        desc: this.userInput,
        viewerId: this.userId,
        key: new Date().getTime()
      };
      this.sendRoomMessage(obj);
      obj.desc = text;
      this.selectInoutList[0].push(obj);
      this.inoutList = JSON.parse(JSON.stringify(this.selectInoutList[0]));
      this.userInput = '';
    },
    // 加入聊天室
    addMessageRoom () {
      let chatRoomId = this.room_account;
      let count = 10;
      let callback = {
        onSuccess: (msg) => {
          // let obj = {
          //   key: new Date().getTime(),
          //   type: 1, // 1 是聊天列表
          //   avator: JSON.parse(localStorage.userInfo).avatar_url,
          //   action: '进入了直播间',
          //   name: JSON.parse(localStorage.userInfo).user_name,
          //   desc: '',
          //   viewerId: this.userId,
          //   isShowAction: false,
          //   id: JSON.parse(localStorage.userInfo).chat_account,
          //   chatId: this.roomId
          // };
          // this.sendConfigMessage(obj);
          // this.sendRoomMessage(obj); // 加入聊天室成功后向聊天室发送消息
        },
        onError: () => {}
      };
      RongIMClient.getInstance().joinChatRoom(chatRoomId, count, callback);
    },
    // 初始化聊天室消息类型
    initRoomMessage () {
      let messageName = 'LivePersonMessage'; // 消息名称
      let objectName = 's:person'; // 消息类型名，请按照此格式命名
      let isCounted = true; // 消息计数
      let isPersited = true; // 消息保存
      let mesasgeTag = new RongIMLib.MessageTag(isCounted, isPersited);
      let prototypes = ['action', 'name', 'chatId', 'desc', 'viewerId', 'type', 'avator', 'msgType', 'key', 'isShowAction', 'id']; // 消息类中的属性名
      RongIMClient.registerMessageType(messageName, objectName, mesasgeTag, prototypes);
    },
    sendRoomMessage (info) {
      let conversationType = RongIMLib.ConversationType.CHATROOM;
      let targetId = this.room_account;
      let msg = new RongIMClient.RegisterMessage.LivePersonMessage(info);

      let callback = {
        onSuccess: (message) => {
        },
        onError: (errorCode) => {
        }
      };
      RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, callback);
    },
    // 监听接收消息处理事件
    handleReciveMessage (message) {
      let content = {};
      if (message.content.message) {
        // 手机
        let obj = message.content.message.content;
        content = JSON.parse(JSON.stringify(obj));
        content.name = obj.user.name;
        content.avator = obj.user.portrait;
        content.viewerId = obj.user.id;
        content.isShowAction = false;
        delete content.user;
      } else {
        // 平台
        content = message.content;
      }
      if (content.type === 1) {
        // 判断是进入还是离开
        if (content.action === '进入了直播间') {
          // 加入左侧用户列表之前判断是否存在 不存在才添加
          if (this.selectUserList[0].length) {
            this.selectUserList[0].forEach(item => {
              if (item.viewerId !== content.viewerId) {
                this.selectUserList[0].push(content);
              }
            });
          } else {
            this.selectUserList[0].push(content);
          }
        } else {
          if (this.selectUserList[0].length) {
            this.selectUserList[0].forEach((item, index) => {
              if (item.viewerId === content.viewerId) {
                this.selectUserList[0].splice(index, 1);
              }
            });
          }
        }
        this.selectInoutList[0].push(content);
        this.inoutList = JSON.parse(JSON.stringify(this.selectInoutList[0]));
        this.userList = JSON.parse(JSON.stringify(this.selectUserList[0]));
      } else if (content.type === 2) {
        // 发言 只要右边添加
        content.desc = RongIMLib.RongIMEmoji.symbolToEmoji(content.desc);
        this.selectInoutList[0].push(content);
        this.inoutList = JSON.parse(JSON.stringify(this.selectInoutList[0]));
      } else if (content.type === 3) {
        // 礼物消息
        content.giftList = [];
        this.showGift(content);
        if (this.selectInoutList[1].length) {
          this.selectInoutList[1].forEach((item, index) => {
            if (item.viewerId === content.viewerId) {
              // 说明是同一个人赠送的礼物
              this.selectInoutList[1][index].number += content.number;
              let postion = '';
              let bool = this.selectInoutList[1][index].giftList.some((item, index) => {
                // item.giftName === content.giftName ? postion = index : '';
                if (item.giftName === content.giftName) {
                  postion = index;
                }
                return item.giftName === content.giftName;
              });
              bool ? this.selectInoutList[1][index].giftList[postion].number += content.number : this.selectInoutList[1][index].giftList.push({giftName: content.giftName, number: content.number});
              // this.selectInoutList[1][index].giftList.push({giftName: content.giftName, number: content.number});
            } else {
              content.giftList.push({giftName: content.giftName, number: content.number});
              this.selectInoutList[1].push(content);
            }
          });
        } else {
          content.giftList.push({giftName: content.giftName, number: content.number});
          this.selectInoutList[1].push(content);
        }
      } else if (content.type === 4) {
        // 被管理员关闭直播间
        this.rongRoom.leave().then(() => {
          this.removeUserStream('该直播间已被管理员关闭！');
        }, () => {
          this.$message.error('服务已断开连接!');
        });
      } else if (content.type === 5 || content.type === 6) {
        // 点赞及关注信息
        this.selectInoutList[0].push(content);
        if (this.curentShow === 0) {
          this.inoutList = JSON.parse(JSON.stringify(this.selectInoutList[0]));
        };
        // this.curentShow === 0 ? this.inoutList = JSON.parse(JSON.stringify(this.selectInoutList[0])) : '';
      } else if (content.type === 14) {
        this.uploadVideoUrl = content.desc;
      }
    },
    handleShowCard (item, index) {
      this.currentIndex = index;
      this.userList[index].isShowAction = true;
    },
    moveBan (item) {
      if (this.banText === '设置封禁时长') {
        this.$post({
          url: '/wy_broadcast/rooms/block',
          params: {
            ...this.banUser
          }
        }).then(res => {
          this.$message.success(res.msg);
          item.banTime = res.data.time;
          this.selectUserList[2].push(item);
          this.selectUserList[0].splice(this.currentIndex, 1);
          this.userList.splice(this.currentIndex, 1);
        });
      } else {
        this.$post({
          url: '/wy_broadcast/rooms/gag',
          params: {
            ...this.banUser
          }
        }).then(res => {
          item.banTime = res.data.time;
          this.$message.success(res.msg);
          this.selectUserList[1].push(item);
        });
      }
    },
    removeBan (item, index) {
      if (this.banText === '设置封禁时长') {
        this.$post({
          url: '/wy_broadcast/rooms/unblock',
          params: {
            room_account: this.$route.query.rcId,
            chat_account: item.viewerId
          }
        }).then(res => {
          this.$message.success(res.msg);
          this.selectUserList[2].splice(index, 1);
          this.selectUserList[0].push(item);
          this.userList = JSON.parse(JSON.stringify(this.selectUserList[2]));
        });
      } else {
        this.$post({
          url: '/wy_broadcast/rooms/ungag',
          params: {
            room_account: this.$route.query.rcId,
            chat_account: item.viewerId
          }
        }).then(res => {
          this.$message.success(res.msg);
          this.selectUserList[1].splice(index, 1);
          this.userList = JSON.parse(JSON.stringify(this.selectUserList[1]));
        });
      }
    },
    handleAction (index) {
      switch (index) {
        case 0:
          // 封禁用户
          this.isShowSelect = false;
          this.banText = '设置封禁时长';
          this.banUser.minute = this.currentTime;
          break;
        case 1:
          // 禁言用户
          this.isShowSelect = false;
          this.banText = '设置禁言时长';
          this.banUser.minute = this.currentTime;
          break;
      }
    },
    handleChangeSelect (value) {
      this.currentTime = value;
    },
    handleConfigBan (item) {
      this.handleClickBody();
      this.banUser.minute = this.currentTime;
      this.banUser.chat_account = item.viewerId;
      this.banUser.room_account = this.$route.query.rcId;
      this.moveBan(item);
    },
    handleClickBody (e) {
      if (!e) return;
      if (e.target.className !== 'ant-select-selection__rendered' && e.target.className !== 'ant-select-dropdown-menu-item ant-select-dropdown-menu-item-selected') {
        this.isShowSelect = true;
        this.userList.forEach(item => {
          item.isShowAction = false;
        });
      }
    },
    // 礼物展示
    showGift (content) {
      if (!this.isShowGift) {
        this.isShowGift = true;
        for (let k in content) {
          for (let v in this.giftInfo) {
            if (k === v) {
              this.giftInfo[v] = content[k];
            }
          }
        }
        setTimeout(() => {
          this.isShowGift = false;
        }, 3000);
      }
    },
    recursionList (list) {
      if (!list.length) return;
      this.giftInfo = list[0];
      this.isShowGift = true;
      setTimeout(() => {
        list.splice(0, 1);
        this.isShowGift = false;
        this.recursionList(list);
      }, 3000);
    },
    async shareVideo () {
      let stream = null;
      let config = {
        video: true,
        audio: true,
        height: 480,
        width: 640,
        frameRate: 15,
        screen: true,
        desktopStreamId: 'desktopStreamId'
      };
      try {
        // { video: true, audio: true }
        stream = await navigator.mediaDevices.getDisplayMedia(config);
        this.publishRTC(stream);
        stream.getVideoTracks()[0].onended = () => {
          // 监听停止了屏幕共享……
          // this.publishRTC(this.liveMediaStream);
          this.unpublishRTC(stream);
        };
        // const videoEle = document.createElement('video')
        // videoEle.autoplay = true;
        // videoEle.srcObject= stream;
        // let users = {
        //   id: this.userId,
        //   stream: {
        //       tag: 'RongCloudRTC',
        //       type: this.myRongRTC.StreamType.AUDIO_AND_VIDEO,
        //       mediaStream: stream
        //   }
        // };
        // this.myStream.publish(users);
      } catch (e) {
      }
    },
    // 发布/停止 共享屏幕资源
    publishRTC (stream) {
      let users = {
        id: this.userId,
        stream: {
          tag: 'RongCloudRTC',
          type: this.myRongRTC.StreamType.AUDIO_AND_VIDEO,
          mediaStream: stream
        }
      };
      this.myStream.publish(users);
    },
    unpublishRTC (stream) {
      let users = {
        id: this.userId,
        stream: {
          tag: 'RongCloudRTC',
          type: this.myRongRTC.StreamType.AUDIO_AND_VIDEO
        }
      };
      this.myStream.unpublish(users).then(result => {
      }, () => {});
    },
    // 全屏
    Screen () {
      let element = document.getElementById(this.userId);
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      } else if (element.oRequestFullscreen) {
        element.oRequestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullScreen();
      } else {
        let docHtml = document.documentElement;
        let docBody = document.body;
        let videobox = document.getElementById(this.userId);
        let cssText = 'width:100%;height:100%;overflow:hidden;';
        docHtml.style.cssText = cssText;
        docBody.style.cssText = cssText;
        videobox.style.cssText = cssText + ';' + 'margin: 0px;padding: 0px;';
        document.IsFullScreen = true;
      }
    },
    getNodeHtml (node) {
      return node.outerHTML;
    },
    setEmoji (emoji) {
      this.userInput += emoji;
      this.isShowEmoji = false;
    }
  }
};
